import React from 'react';
// import './index.css'

const CookiePolicy = () => {
    return (
        <div className="context">
            <h1 style={{textAlign: 'center', fontSize: '2.5em', color: '#fff', marginBottom: '20px'}}>COOKIE POLICY</h1>
            <p style={{fontSize: '1.2em', marginBottom: '20px'}}>
                Vishwa Ltd, a Cayman Islands company, maintains Vishwa, AI infrastructure for autonomous finance, and
                provides access to Vishwa through various websites and related technologies (collectively referred to as
                the "Websites" and the "Service"). This Cookie Policy explains how we use cookies and similar
                technologies on our Websites to enhance user experience, ensure site functionality, and support our
                operations. This Policy should be read in conjunction with our Privacy Policy.
            </p>

            <h2 style={{fontSize: '1.8em', color: '#fff', marginTop: '30px'}}>What Are Cookies and Similar
                Technologies:</h2>
            <ul style={{paddingLeft: '20px', marginBottom: '20px', listStyle: 'disc'}}>
                <li>
                    <strong>Cookies:</strong>
                    <ul style={{listStyle: 'circle', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li>
                            <strong>Definition:</strong> Cookies are small text files placed on your device by websites
                            to uniquely identify your browser or store information and settings.
                        </li>
                        <li>
                            <strong>Purpose:</strong> Cookies help us personalize your experience, facilitate seamless
                            navigation, enable essential site functions, and analyze how our Services are used. They
                            also assist in delivering relevant content and advertisements.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Local Storage:</strong>
                    <ul style={{listStyle: 'circle', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li>
                            <strong>Definition:</strong> A technology similar to cookies, local storage allows websites
                            to store larger amounts of data directly on your device.
                        </li>
                        <li>
                            <strong>Purpose:</strong> Unlike cookies, which are limited in size, local storage can hold
                            more substantial data such as application-specific settings, allowing for richer and more
                            responsive user experiences.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Web Beacons:</strong>
                    <ul style={{listStyle: 'circle', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li>
                            <strong>Definition:</strong> Also known as pixel tags or clear GIFs, web beacons are tiny,
                            invisible images embedded within web pages or emails.
                        </li>
                        <li>
                            <strong>Purpose:</strong> Web beacons help us track whether a webpage or email has been
                            viewed or interacted with. This information is crucial for measuring the effectiveness of
                            our content, understanding user engagement, and refining our communication strategies.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Embedded Scripts:</strong>
                    <ul style={{listStyle: 'circle', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li>
                            <strong>Definition:</strong> An embedded script is a piece of programming code integrated
                            into a website to track user interactions, such as clicks and page views. This code is
                            temporarily stored on the user’s device and functions only during the site visit.
                        </li>
                        <li>
                            <strong>Purpose:</strong> The primary purpose of embedded scripts is to enhance website
                            functionality by monitoring user engagement. This helps improve user experience and allows
                            site owners to gather data on website performance and visitor behaviour.
                        </li>
                    </ul>
                </li>
            </ul>
            <h2 style={{fontSize: '1.8em', color: '#fff', marginTop: '30px'}}>Types of Cookies and Their Purposes:</h2>
            <p>
                Our Websites use cookies to distinguish you from other users, enhancing your browsing experience and
                helping us improve our services. By continuing to browse, you agree to our use of cookies as outlined in
                this policy. A cookie is a small file stored on your browser or computer if you consent, containing
                information transferred to your device's hard drive. We may use the following types of cookies:
            </p>
            <ul style={{paddingLeft: '20px', marginBottom: '20px', listStyle: 'none'}}>
                <li>
                    <strong>Types of Cookies According to Usage Periods:</strong>
                    <ul style={{listStyle: 'disc', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li><strong>Persistent Cookies:</strong> A persistent cookie remains stored in your browser and
                            helps us recognize you on your return visits, making it easier for you to interact with our
                            services.
                        </li>
                        <li><strong>Session Cookies:</strong> A session cookie is temporary and enables smooth
                            navigation between pages. It remembers your inputs while browsing and is deleted once you
                            close your browser or after a short period.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Types of Cookies by Source</strong>
                    <ul style={{listStyle: 'disc', paddingLeft: '20px', marginBottom: '10px'}}>
                        <li><strong>First-party Cookies:</strong> These cookies are placed directly by the website or
                            service you are using. They can either be set by us or by a third party on our behalf to
                            improve your experience.
                        </li>
                        <li><strong>Third-party Cookies:</strong> These cookies are placed by external entities other
                            than the website you’re visiting, often used for purposes like tracking or delivering
                            targeted content.
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Types of Cookies Based on Their Purpose</strong>
                    <ul style={{listStyle: 'disc'}}>
                        <li>Strictly Necessary Cookies:</li>
                        <ul style={{listStyle: 'circle'}}>
                            <li>Function:These cookies are essential for the operation of
                                our Websites. They enable
                                fundamental functions such as secure logins, shopping cart operations, and payment
                                processing.
                            </li>
                            <li>Reason for Use:Without these cookies, many core
                                services
                                cannot be provided, such as
                                accessing secure areas of the site or completing transactions. They are necessary
                                for
                                the website’s operation and your use of our Services.
                            </li>
                        </ul>

                        <li>Analytical/Performance Cookies:</li>
                        <ul style={{listStyle: 'circle'}}>
                            <li>Function:These cookies allow us to monitor and analyze how
                                visitors interact with our Websites. They track metrics like page views, user flows, and
                                error rates.
                            </li>
                            <li>Reason for Use:By understanding user behavior, we can
                                optimize the functionality of our Websites, ensuring that visitors can easily find what
                                they’re looking for and improving the overall user experience. For instance, these
                                cookies help us identify popular content, troubleshoot issues, and make data-driven
                                decisions to enhance site performance.
                            </li>
                        </ul>

                        <li>Functionality Cookies:</li>
                        <ul style={{listStyle: 'circle'}}>
                            <li>Function:Functionality cookies remember your preferences
                                and choices, such as your language, region, or username. They enable us to personalize
                                your experience on return visits.
                            </li>
                            <li>Reason for Use:These cookies improve usability by saving
                                your settings, so you don’t have to re-enter information each time you visit. They help
                                create a tailored experience, making your interactions with our Websites more efficient
                                and enjoyable.
                            </li>
                        </ul>

                        <li>Targeting Cookies:</li>
                        <ul style={{listStyle: 'circle'}}>
                            <li>Function:These cookies track your online activity,
                                including the pages you visit and the links you click on. They help us deliver
                                advertisements that are more relevant to you and measure the effectiveness of our
                                marketing campaigns.
                            </li>
                            <li>Reason for Use:Targeting cookies enable us to provide you
                                with personalized advertising based on your interests and browsing history. They also
                                help us understand the impact of our ads and refine our marketing strategies to better
                                meet your needs.
                            </li>
                        </ul>
                    </ul>
                </li>
            </ul>

            <h2 style={{fontSize: '1.8em', color: '#fff', marginTop: '30px'}}>Managing Your Cookie Preferences:</h2>
            <ul>
                <p>There are a number of ways to limit online tracking, which we have summarized below:</p>
                <ul style={{listStyle: 'disc'}}>
                    <li>Browser Settings: Most web browsers allow you to control
                        cookies, including blocking or deleting them. This can be done through your browser’s
                        settings, where you can choose to reject cookies or clear them after your session.
                        <ul style={{listStyle: 'circle'}}>
                            <li>Impact:Blocking or removing cookies may affect your
                                ability to use certain features
                                of our Websites, such as remembering login details or preferences.
                            </li>
                        </ul>
                    </li>
                    <li>Mobile Settings: Your mobile device may have settings that
                        limit the use of the advertising ID for interest-based advertising.
                        <ul style={{listStyle: 'circle'}}>
                            <li>Impact:Adjusting these settings can reduce the
                                personalization of ads shown to you
                                across apps and websites.
                            </li>
                        </ul>
                    </li>

                    <li>Privacy Plugins/Browsers: Plugins or privacy-focused
                        browsers like Privacy Badger, DuckDuckGo, Ghostery, or uBlock Origin can block
                        third-party cookies and trackers.
                        <ul style={{listStyle: 'circle'}}>
                            <li>Impact:These tools offer enhanced privacy but may also
                                limit the functionality of
                                certain services or the ability to personalize content.
                            </li>
                        </ul>
                    </li>
                    <li>Platform Opt-Outs: Major platforms like Facebook, Google,
                        LinkedIn, and Twitter provide opt-out features for targeted advertising.
                        <ul style={{listStyle: 'circle'}}>
                            <li>Impact:Opting out on these platforms reduces targeted
                                ads but does not eliminate all
                                ads; it shifts the type of ads you receive.
                            </li>
                        </ul>
                    </li>

                    <li>Industry Opt-Out Tools: Use tools like the Digital
                        Advertising Alliance (DAA) or Network Advertising Initiative (NAI) to opt out of
                        interest-based advertising across many participating companies.
                        <ul style={{listStyle: 'circle'}}>
                            <li>Impact:These tools provide a broad opt-out mechanism
                                but must be set up on each
                                device and browser you use.
                            </li>
                        </ul>
                    </li>
                    <li>Consent Modal Preferences: In addition to the methods mentioned above, you can manage
                        your cookie preferences directly through the consent modal available on our Website. By
                        using this consent modal, you can choose to prevent your data from being sent to
                        analytics services such as Google Analytics. Even if the relevant cookies remain stored
                        in your browser, no data will be transmitted to these services unless you provide
                        explicit consent.
                    </li>
                </ul>
            </ul>


            <h2 style={{fontSize: '1.8em', color: '#fff', marginTop: '30px'}}>Cookie Details:</h2>
            <table
                style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginBottom: '20px',
                    textAlign: 'left',
                    border: '1px solid #ddd',
                }}
            >
                <thead>
                <tr style={{backgroundColor: '#f2f2f2',color: '#000'}}>
                    <th style={{padding: '10px', border: '1px solid #ddd', width: '120px'}}>Cookie Types</th>
                    <th style={{padding: '10px', border: '1px solid #ddd'}}>Cookie Name</th>
                    <th style={{padding: '10px', border: '1px solid #ddd'}}>Cookie Service Provider</th>
                    <th style={{padding: '10px', border: '1px solid #ddd'}}>Cookie Term</th>
                    <th style={{padding: '10px', border: '1px solid #ddd'}}>Purpose of the Cookie</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Functional</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>i18next</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>i18next (language translation service)</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Typically, session-based</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>
                        This cookie is used for setting the user’s default language for translations.
                    </td>
                </tr>
                <tr>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Strictly Necessary</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>consent_analytics</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Site-specific consent management system</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Usually long-term (1 year or more)</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>
                        This cookie is used for managing user consent for analytics tracking based on consent policies.
                    </td>
                </tr>
                <tr>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Strictly Necessary</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>cf_clearance</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Cloudflare</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>30 minutes to 1 year</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>
                        This cookie is set by Cloudflare when the site uses Cloudflare’s Bot Management or Firewall
                        features.
                    </td>
                </tr>
                <tr>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Analytical</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>_ga_HEZ7GYRX99</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Google Analytics 4 (GA4)</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>1 year</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>
                        This is a specific Google Analytics 4 (GA4) cookie.
                    </td>
                </tr>
                <tr>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Analytical</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>_ga</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>Google Analytics</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>1 year</td>
                    <td style={{padding: '10px', border: '1px solid #ddd'}}>
                        This cookie is set by Google Analytics to distinguish unique users by assigning a randomly
                        generated identifier.
                    </td>
                </tr>
                </tbody>
            </table>

            <h2 style={{fontSize: '1.8em', color: '#fff', marginTop: '30px'}}>Contact Information:</h2>
            <p style={{fontSize: '1.2em', marginBottom: '20px'}}>
                For any questions or concerns regarding this Cookie Policy, please contact us at{' '}
                <a href="mailto:official@vishwanetwork.xyz"
                   style={{color: '#fff', textDecoration: 'underline', display: 'inline-block',}}>
                    official@vishwanetwork.xyz
                </a>
            </p>
        </div>
    );
};

export default CookiePolicy;